import React from "react";
import { Link } from "react-router-dom";
import { FaInstagram, FaFacebook, FaYoutube } from "react-icons/fa";

function Footer() {
  return (
    <footer className="bg-sritaru-800 text-sritaru-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Branding */}
          <div>
            <h3 className="text-xl font-bold text-white mb-2">
              &#127795; SriTaru Sankalpam
            </h3>
            <p className="text-sritaru-300 text-sm">
              An Agroforesting Initiative by
            </p>
            <p className="text-white font-semibold mt-1">
              B+ Kathakala Brindavam
            </p>
            <a
              href="https://utsavam.kathakala.us"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block mt-3 text-earth-200 hover:text-earth-100 text-sm underline"
            >
              Visit Kathakala Utsavam &rarr;
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-3">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/contribute"
                  className="hover:text-white transition-colors"
                >
                  Contribute
                </Link>
              </li>
              <li>
                <Link
                  to="/wall"
                  className="hover:text-white transition-colors"
                >
                  Contributor Wall
                </Link>
              </li>
              <li>
                <a
                  href="https://sankalptaru.org/c/bpluswithbhaskar/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  Geo-tagged Trees on SankalpTaru
                </a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-white font-semibold mb-3">Follow Us</h4>
            <div className="flex space-x-4 mb-4">
              <a
                href="https://www.instagram.com/reel/DS_H2GuDhFj/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sritaru-300 hover:text-white transition-colors"
                aria-label="Instagram"
              >
                <FaInstagram size={24} />
              </a>
              <a
                href="https://www.facebook.com/share/v/1CuPDzwmBX/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sritaru-300 hover:text-white transition-colors"
                aria-label="Facebook"
              >
                <FaFacebook size={24} />
              </a>
              <a
                href="https://www.youtube.com/watch?v=eCJxRJQpG4U"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sritaru-300 hover:text-white transition-colors"
                aria-label="YouTube"
              >
                <FaYoutube size={24} />
              </a>
            </div>
            <a
              href="https://sankalptaru.org"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-earth-200 hover:text-white transition-colors underline"
            >
              sankalptaru.org
            </a>
          </div>
        </div>

        <div className="border-t border-sritaru-700 mt-8 pt-6 text-center text-sm text-sritaru-400">
          &copy; {new Date().getFullYear()} B+ Kathakala Brindavam. All rights
          reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
